<div class="d-flex justify-content-between">
  <b class="text-nowrap">{{name}}</b>
  <div ngbDropdown style="min-width:4em; text-align: right;">
    <button class="btn btn-sm m-0 py-0 ms-auto" ngbDropdownToggle>
      <i class="fa fa-filter"></i>
    </button>
    <ul class="dropdown-menu p-2 table-dropdown" ngbDropdownMenu>
      <li class="text-nowrap" *ngFor="let val of lookupValues">
        <span (click)="selectValue.emit(val)">
          <i [ngClass]="{'fa-regular fa-square': true, 'fa-square-check': selectedValues.includes(val?.id || -1)}"></i>
          <small class="ms-2">{{val.text}}</small>
        </span>
      </li>
    </ul>
  </div>
</div>
